import React from "react";
import "./DailyRewardModal.css";

export default function LevelUpModal({ isOpen, onClose, newRank, newTitle }) {
  if (!isOpen) return null;

  const getUnlocks = (rank) => {
    switch (Number(rank)) {
      case 2: return "Tipping";
      case 3: return "Daily Reward";
      case 4: return "Star Ratings"
      case 5: return "Weekly Jackpot"
      case 6: return "Forex";
      case 7: return "Transfers";
      case 8: return "Contracts";
      case 9: return "Futures";
      case 10: return "Politics";
      default: return "More coming soon!";
    }
  };

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal-container level-up-container">
        
        {/* Visual Glow */}
        <div className="rank-glow-effect"></div>

        <div className="confirm-modal-title level-up-title">
          PROMOTION UNLOCKED
        </div>

        <div className="confirm-modal-message">
          <div className="rank-badge">RANK {newRank}</div>
          
          <p className="congrats-heading">Congratulations!</p>
          <h2 className="new-title-display">{newTitle}</h2>
          
          <div className="unlock-shimmer-box">
             <span className="unlock-label">UNLOCKED</span>
             <p className="unlock-feature-text">{getUnlocks(newRank)}</p>
          </div>
        </div>

        <div className="confirm-modal-actions">
          <button className="settings-button confirm level-up-btn" onClick={onClose}>
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
}